import { CheckCircle2, FileText, Users, Calendar } from 'lucide-react';

const STEPS = [
  {
    id: 'step-solicita',
    icon: <FileText className="w-8 h-8 text-[#43b6b8]" />,
    title: '1. Solicita Información',
    description: 'Completa el formulario y nos pondremos en contacto contigo.'
  },
  {
    id: 'step-agenda',
    icon: <Calendar className="w-8 h-8 text-[#43b6b8]" />,
    title: '2. Llamada de Orientación',
    description: 'Conversamos sobre tu hijo y resolvemos todas tus preguntas.'
  },
  {
    id: 'step-evaluacion',
    icon: <Users className="w-8 h-8 text-[#43b6b8]" />,
    title: '3. Evaluación Inicial',
    description: 'Conocemos al estudiante y sus necesidades específicas.'
  },
  {
    id: 'step-matricula',
    icon: <CheckCircle2 className="w-8 h-8 text-[#43b6b8]" />,
    title: '4. Matrícula',
    description: 'Completa el proceso y comienza el apoyo académico.'
  }
];

export const AdmisionProcess = () => (
  <section className="py-20 md:py-28" data-testid="proceso-section">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
      <div className="text-center mb-16">
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#d3b163] mb-4 block">Proceso Simple</span>
        <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-stone-900 mb-4">
          4 pasos para unirte a nuestra comunidad
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {STEPS.map((step) => (
          <div
            key={step.id}
            className="text-center"
            data-testid={`admission-step-${step.id}`}
          >
            <div className="bg-white p-8 rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] mb-4">
              <div className="flex justify-center mb-4">{step.icon}</div>
              <h3 className="text-lg font-medium text-stone-900 mb-2">{step.title}</h3>
              <p className="text-sm text-stone-700 leading-relaxed">{step.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
